// extracted by mini-css-extract-plugin
export default {"main":"_404_main__mE34-"};